// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"vy_a bhh_b bhh_wb"};